import React from 'react'
import Career from '../Components/Career'

function JobCareer() {
  return (
    <>
      <div className="row mt-5"></div>

      <Career />

    </>
  )
}

export default JobCareer
